import type { BackDropTokens } from './types';

export const backDrop: BackDropTokens = {
  colors: {
    background: 'rgba(39, 39, 39, 0.6)',
  },
};
